import { defineStore } from "pinia";
import { useLocalStorage } from "@vueuse/core";

import lightTheme from "@/themes/l-rosepinedawn.json5";
import darkTheme from "@/themes/d-rosepine.json5";
import { Theme } from "@/scripts/theme";

export const exportableDevicePrefsStoreKeys: (keyof ReturnType<
    typeof useDevicePreferencesStore
>["preferences"])[] = [
    "theme",
    "fontSize",
    "useSystemFont",
    "lightTheme",
    "darkTheme",
    "syncDeviceDarkMode",
    "mediaVolume",
    "sound_masterVolume",
    "sound_note",
    "sound_noteMy",
    "sound_notification",
    "sound_chat",
    "sound_chatBg",
    "sound_antenna",
    "sound_channel",
    "wallpaper",
    "ui",
];

export const devicePreferencesStoreDefaults = {
    ui: null as "default" | "classic" | "deck" | null,
    theme: null as Theme["props"] | null,
    colorScheme: null as "dark" | "light" | null,
    wallpaper: null as string | null,
    fontSize: null as null | string,
    customCss: "",
    useSystemFont: false,
    themeInitial: true,
    lightTheme: lightTheme as Theme,
    darkTheme: darkTheme as Theme,
    syncDeviceDarkMode: true,
    mediaVolume: 0.5,
    sound_masterVolume: 0.3,
    sound_note: { type: "none", volume: 0 },
    sound_noteMy: { type: "syuilo/up", volume: 1 },
    sound_notification: { type: "syuilo/pope2", volume: 1 },
    sound_chat: { type: "syuilo/pope1", volume: 1 },
    sound_chatBg: { type: "syuilo/waon", volume: 1 },
    sound_antenna: { type: "syuilo/triple", volume: 1 },
    sound_channel: { type: "syuilo/square-pico", volume: 1 },
};

export const useDevicePreferencesStore = defineStore("devicePrefs", {
    state: () => ({
        preferences: useLocalStorage(
            "mag/device/prefs",
            devicePreferencesStoreDefaults,
            { listenToStorageChanges: true, deep: true, mergeDefaults: true },
        ),
    }),
});
